// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WMmcWJ5gc165zK {
  flex-shrink: 0;
  height: 32px;
  max-height: 32px;
  margin-right: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-0, 0);
  margin-left: var(--ds-space-0, 0);
  line-height: 32px;
}
@media only screen and (max-width: 1540px) {
  .WMmcWJ5gc165zK .q258TF0vTHbche {
    min-width: 32px;
    height: 32px;
    padding: var(--ds-space-075, 6px);
  }
}
@media only screen and (max-width: 1540px) {
  .WMmcWJ5gc165zK .yq4ziNuzqhxYOs {
    margin-right: var(--ds-space-0, 0);
  }
}
@media only screen and (max-width: 1540px) {
  .WMmcWJ5gc165zK .FQS9jJWHNTxTo8 {
    display: none;
  }
}
.WMmcWJ5gc165zK.KeUcmQlkuvPtdG .q258TF0vTHbche {
  min-width: 32px;
  height: 32px;
  padding: var(--ds-space-075, 6px);
}
.WMmcWJ5gc165zK.KeUcmQlkuvPtdG .yq4ziNuzqhxYOs {
  margin-right: var(--ds-space-0, 0);
}
.WMmcWJ5gc165zK.KeUcmQlkuvPtdG .FQS9jJWHNTxTo8 {
  display: none;
}
.oHQ8obc2i5j1_X {
  margin-top: var(--ds-space-200, 16px);
  margin-bottom: var(--ds-space-200, 16px);
}
.c67dXVOH2YRrxT {
  margin: var(--ds-space-100, 8px) var(--ds-space-0, 0px);
}
.oeDGFynpzVL448 {
  margin-bottom: var(--ds-space-0, 0);
}
.wen_1Cq2J98NpI {
  margin-right: var(--ds-space-050, 4px);
  margin-left: var(--ds-space-050, 4px);
}
.XWewOOJgyZOgt_ {
  overflow: visible;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardVisibilityContainer": `WMmcWJ5gc165zK`,
	"boardVisibilityButton": `q258TF0vTHbche`,
	"boardVisibilityIcon": `yq4ziNuzqhxYOs`,
	"boardVisibilityText": `FQS9jJWHNTxTo8`,
	"collapsed": `KeUcmQlkuvPtdG`,
	"publicConfirmButton": `oHQ8obc2i5j1_X`,
	"divider": `c67dXVOH2YRrxT`,
	"shareLinkText": `oeDGFynpzVL448`,
	"shareLinkButton": `wen_1Cq2J98NpI`,
	"inviteDialog": `XWewOOJgyZOgt_`
};
export default ___CSS_LOADER_EXPORT___;
